import React from "react";
// import { Link } from "react-router-dom";
import * as Styled from "./Style";
import bagIcon from "../../assets/images/icons/ic_bag.svg";
import detailsIcon from "../../assets/images/icons/ic_details.svg";
import paymentIcon from "../../assets/images/icons/ic_payment.svg";

const MobileNav = (props) => {
  return (
    <Styled.MobileNavStyle className={props.className}>
      {/* <button onClick={props.goToBag}> Click to scroll </button> */}
      {/* <ScrollLink to="accordionBag">Bagxx</ScrollLink> */}
      <button onClick={props.scrollToBag}>
        <img
          // src={bagIcon}
          src={`${bagIcon}`}
          alt=""
        />
        Bag
      </button>
      <button onClick={props.scrollToDetails}>
        <img
          // src={detailsIcon}
          src={`${detailsIcon}`}
          alt=""
        />
        Your Details
      </button>
      <button onClick={props.scrollToPayment}>
        <img
          // src={paymentIcon}
          src={`${paymentIcon}`}
        />
        Payment
      </button>
    </Styled.MobileNavStyle>
  );
};

export default MobileNav;
